import { SerializedConstructor } from '@langchain/core/load/serializable';

import { ToolDefinition } from 'node_modules/@langchain/core/dist/language_models/base';
import { useState } from 'react';

import { PlaygroundCreatePromptModal } from '@/Pages/Prompts/PromptsCreate';
import {
  CommitWithLookupsSchema,
  RepoExampleSchema,
  RepoWithLookupsSchema,
} from '@/types/schema';

import {
  fixLangChainJSStructuredOutputKwargs,
  maybeReplaceModelProvider,
  replaceTools,
} from '../utils/Playground.utils';
import { PlaygroundIcon } from './PlaygroundButtons';

export function PlaygroundHomeSave(props: {
  manifest: SerializedConstructor;
  examples: RepoExampleSchema[];
  disabled?: boolean;
  onSuccess?: (
    repoWithLookups: RepoWithLookupsSchema,
    commit: CommitWithLookupsSchema
  ) => void;
  replaceTools?: ToolDefinition[];
}) {
  const [createPromptModalOpen, setCreatePromptModalOpen] = useState(false);

  const manifestForSaving = fixLangChainJSStructuredOutputKwargs(
    maybeReplaceModelProvider(props.manifest)
  );
  const manifestWithTools = props.replaceTools
    ? replaceTools(manifestForSaving, props.replaceTools)
    : manifestForSaving;

  return (
    <>
      <PlaygroundIcon
        className="my-1 border-brand text-brand-tertiary"
        tooltipTitle="Save prompt"
      >
        <button
          type="button"
          onClick={() => setCreatePromptModalOpen(true)}
          className="px-1 py-[3px]"
        >
          Save
        </button>
      </PlaygroundIcon>

      <PlaygroundCreatePromptModal
        open={createPromptModalOpen}
        manifest={
          (manifestWithTools as SerializedConstructor) ??
          props.manifest ??
          undefined
        }
        onClose={() => {
          setCreatePromptModalOpen(false);
        }}
        onSuccess={props.onSuccess}
      />
    </>
  );
}
